(() => {
  const motionQuery = window.matchMedia('(min-width: 750px) and (prefers-reduced-motion: no-preference)');
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const galleries = new Set();

  if (!motionQuery.matches || connection?.saveData) return;

  const idle = (callback) => window.setTimeout(callback, 300);

  function loadSlide(gallery, index) {
    if (index === 0) return Promise.resolve(gallery.primary);
    if (gallery.slides[index]) return Promise.resolve(gallery.slides[index]);

    const source = gallery.sources[index - 1];
    if (!source) return Promise.resolve(null);

    return new Promise((resolve) => {
      const image = new Image();
      image.className = 'card-media-image pd-card-gallery-image';
      image.alt = source.alt;
      image.decoding = 'async';
      image.loading = 'eager';
      image.sizes = gallery.sizes;
      image.addEventListener('load', () => {
        gallery.frame.append(image);
        gallery.slides[index] = image;
        resolve(image);
      }, { once: true });
      image.addEventListener('error', () => resolve(null), { once: true });
      image.srcset = source.srcset;
      image.src = source.src;
    });
  }

  function showSlide(gallery, index) {
    gallery.slides.forEach((slide, slideIndex) => {
      if (slideIndex > 0 && slide) slide.classList.toggle('is-active', slideIndex === index);
    });
    gallery.frame.classList.toggle('pd-gallery-showing-secondary', index > 0);
    gallery.current = index;
  }

  async function advance(gallery) {
    if (!gallery.visible || document.hidden) return;
    const next = (gallery.current + 1) % (gallery.sources.length + 1);
    const slide = await loadSlide(gallery, next);
    if (!gallery.visible || document.hidden || (next > 0 && !slide)) return;
    showSlide(gallery, next);
  }

  function start(gallery) {
    if (gallery.timer || !gallery.visible || document.hidden) return;
    idle(() => {
      if (gallery.visible && !document.hidden) loadSlide(gallery, 1);
    });
    gallery.timer = window.setInterval(() => advance(gallery), 6000 + gallery.stagger);
  }

  function stop(gallery) {
    if (!gallery.timer) return;
    window.clearInterval(gallery.timer);
    gallery.timer = null;
  }

  function refreshVisibility(gallery) {
    const rect = gallery.card.getBoundingClientRect();
    const visible = rect.bottom > -100 && rect.top < window.innerHeight + 100;
    if (visible === gallery.visible) return;
    gallery.visible = visible;
    if (visible) start(gallery);
    else stop(gallery);
  }

  function init(root = document) {
    root.querySelectorAll('[data-pd-card-gallery]:not([data-pd-gallery-ready])').forEach((card, index) => {
      const frame = card.querySelector('[data-pd-gallery-frame], .aspect-ratio');
      const primary = frame?.querySelector('.pd-card-gallery-primary, .card-media-image');
      const template = frame?.querySelector('template.pd-card-gallery-sources');
      if (!frame || !primary || !template) return;

      const sources = [...template.content.querySelectorAll('[data-src]')].map((node) => ({
        alt: node.dataset.alt || primary.alt || '',
        src: node.dataset.src,
        srcset: node.dataset.srcset || ''
      }));
      if (!sources.length) return;

      const gallery = {
        card,
        current: 0,
        frame,
        primary,
        sizes: primary.sizes || '(min-width: 1200px) 420px, 33vw',
        slides: [primary],
        sources,
        stagger: (index % 5) * 420,
        timer: null,
        visible: false
      };

      card.dataset.pdGalleryReady = 'true';
      galleries.add(gallery);
      refreshVisibility(gallery);
    });
  }

  document.addEventListener('visibilitychange', () => {
    galleries.forEach((gallery) => {
      if (document.hidden) stop(gallery);
      else if (gallery.visible) start(gallery);
    });
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  let visibilityFrame = null;
  const queueVisibilityRefresh = () => {
    if (visibilityFrame) return;
    visibilityFrame = window.requestAnimationFrame(() => {
      galleries.forEach(refreshVisibility);
      visibilityFrame = null;
    });
  };
  window.addEventListener('scroll', queueVisibilityRefresh, { passive: true });
  window.addEventListener('resize', queueVisibilityRefresh, { passive: true });
  init();
  window.setTimeout(queueVisibilityRefresh, 600);
})();
